import { ChartColorsEnum } from "app/constants/dashboardConst";
import React, { memo } from "react";
import { Trans } from "react-i18next";

interface IProps {
  positive: boolean;
  i18nKey: string;
}

const LabelBox = ({ positive }: Pick<IProps, "positive">) => {
  return (
    <span
      style={{
        display: "inline-block",
        width: 10,
        aspectRatio: 1,
        backgroundColor: positive ? ChartColorsEnum.RED : ChartColorsEnum.BLUE,
        borderRadius: 2,
      }}
    />
  );
};

export const ChartTestFlowToggleLabel = memo(
  ({ i18nKey, positive }: IProps) => {
    return (
      <Trans
        i18nKey={i18nKey}
        components={{ box: <LabelBox positive={positive} /> }}
      />
    );
  }
);
